import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { axiosGetData } from "@shared/api/clients";
import { PrivacyPolicyResponse } from "./privacy-policy.types";

const PRIVACY_POLICY_ENDPOINT = "v1/legal-documents/privacy-policy";

export const PRIVACY_POLICY_QUERY_KEY = [
  "legal-documents",
  "PRIVACY_POLICY",
] as const;

export const usePrivacyPolicyQuery = () => {
  return useQuery<PrivacyPolicyResponse, AxiosError>({
    queryKey: PRIVACY_POLICY_QUERY_KEY,
    queryFn: () =>
      axiosGetData<PrivacyPolicyResponse>(PRIVACY_POLICY_ENDPOINT),
  });
};
